import { render } from "./FilterItemSort.vue?vue&type=template&id=63ae106c&scoped=true"
import script from "./FilterItemSort.vue?vue&type=script&lang=js"
export * from "./FilterItemSort.vue?vue&type=script&lang=js"

import "./FilterItemSort.vue?vue&type=style&index=0&id=63ae106c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ae106c"]])

export default __exports__